<template>
  <div class="faccontent">
    <div class="facdbody">
<!--      <img src="../../../assets/imgs/fac_backimg.png"/>-->
      <!--      <hr  align="center"  width="60%" style="border:1px solid #898989;color: #898989;margin: 0 auto;">-->
      <div class="backbox">
        <div class="divbox"  v-for="(item,index) in listfac" >
          <span  v-html="$i18n.locale=='zh_HK'?item.name:item.nameEn">{{$i18n.locale=='zh_HK'?item.name:item.nameEn}}</span>
          <p v-html="$i18n.locale=='zh_HK'?item.describe:item.describeEn">{{$i18n.locale=='zh_HK'?item.describe:item.describeEn}}
          </p>
          <hr :class="index!=1 && index!=2?'black':'gray'" v-show="index!=1 && index!=2" align="center"  width="80%" style="margin: 1% auto;" >
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import {WOW} from 'wowjs';

  export default {
    name: "facilitiecom",
    //'titlename','textContent'
    props: ['listfac'],
    mounted() {
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
    methods: {
      getimgsrc(imgvalue){
        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      }
    },
  }
</script>

<style lang="less" scoped>
  @media only screen and (min-width: 800px) {
    .faccontent {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 1%;
      overflow: hidden;
      .title {
        margin: 0 auto;
        padding-top: 5%;
        height: 30%;
        width: 90%;
        display: flex;
        /*align-items: center;*/
        flex-direction: column;
        font-size: 1.8em;
        z-index: 999;
        color: black;

        p {
          font-size: 1.4em;
        }

        span {
          text-align: left;
          padding: 1% 0;
          font-size: 0.6em;
        }
      }

      .facdbody {
        margin-top: 5%;
        width: 90%;
        max-width: 1500px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-image: url("../../../assets/imgs/fac_backimg.png");
        .backbox{
          padding: 4% 2%;
          width: 90%;
          .divbox {
            line-height: 2em;
            align-items: center;
            color: black;
            span {
              font-size: 1.2em;
              font-weight: bold;
            }
            p:hover{
              color: #2089b9;
              text-decoration: underline;
            }
            p {
              font-size: 1.2em;
              padding: 2% 0;
              text-align: center;

            }
            .black{
              border:1px solid #2a2a2a;
              color: #2a2a2a;
            }
            .gray{
              border:1px solid #dddddd;
              color: #dddddd;
            }
          }
        }

      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    .faccontent {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 5%;
      .title {
        padding-top: 4%;
        height: 30%;
        width: 100%;
        display: flex;
        /*align-items: center;*/
        flex-direction: column;
        font-size: 1.8em;
        z-index: 999;
        color: black;
        p {
          font-size: 1.7em;
          font-weight: bold;
        }
        span {
          text-align: left;
          padding: 10px 0;
          font-size: 1em;
        }
      }
      .facdbody {
        margin-top: 5%;
        width: 90%;
        max-width: 1500px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-image: url("../../../assets/imgs/fac_backimg.png");
        .backbox{
          padding: 4% 2%;
          width: 90%;
          .divbox {
            line-height: 2em;
            align-items: center;
            color: black;
            span {
              font-size: 1.5em;
              font-weight: bold;
            }
            p {
              font-size: 1.5em;
              padding: 2% 0;
              text-align: center;

            }
            .black{
              border:0.5px solid #000;
              color: #000;
            }
            .gray{
              border:1px solid #dddddd;
              color: #dddddd;
            }
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Facilities/faccomponents/facilitiecom.vue